// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xaxH","questions":"styles_questions__dZDXh","footer":"styles_footer__110JY"};